var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.authPopupShow)?_c('f7-popup',{staticClass:"auth-popup",on:{"popup:closed":_vm.onPopupClosed}},[_c('f7-view',[_c('Auth',{attrs:{"popup":""},on:{"close":_vm.onPopupCloseClick}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }